<template>
  <v-layout column fill-height>
    <v-flex xs1 v-if="!loadedReservas">
      <v-progress-circular
        indeterminate
        color="light-green darken-1"
      ></v-progress-circular>
    </v-flex>
    <v-flex xs12 class="px-2" align-center
      v-for="cabin in cabins"
      :key="cabin.id"
      v-else
    >
      <v-card
        dark class="clickable mb-3"
        @click="navigateTo('Cabaña', {id: cabin.id})"
      >
        <v-card-title primary-title class="light-green darken-1">
          <div class="headline">
            {{cabin.name}}
            <v-avatar
              size="30px"
              color="grey darken-4"
              class="white--text ml-2"
              v-if="cabin.resCount"
            >{{cabin.resCount}}</v-avatar>
          </div>
        </v-card-title>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import mixins from '@/mixins/mixins';

export default {
  computed: {
    loadedReservas() {
      return this.$store.state.loadedReservas;
    },
    cabins() {
      return this.$store.state.cabins;
    }
  },
  mixins: [
    mixins,
  ]
}
</script>
